module.exports = __webpack_public_path__ + "img/bifold-vertical.4f340438.jpg";